module.exports = __webpack_public_path__ + "static/media/bg-green.ca39ef35.svg";